<template>
  <div class="container">
    <!--找回密码成功-->
    <div class="dengl">
      <div class="dly">
        <div class="dlyt fl"><img src="@/view/images/y75.jpg" /></div>
        <div class="dlyw fr">
          <div class="zhmmcg">
            <img src="@/view/images/y74.png" />
            <h5>重置密码成功</h5>
            <p>
              手机号12345678910的用户，您的密码找回成功<br />可以点击下列返回登录界面
            </p>
            <h6><a href="javascript:void(0);" @click="login">返回登录</a></h6>
          </div>
        </div>
      </div>
      <div class="yjd">
        <p>
          Copyright© 2019-2021 印工社（青岛）数字科技有限公司 All Rights
          Reserved<span>|</span
          ><a
            href="https://beian.miit.gov.cn"
            target="_banck"
            style="corsor:pointer"
          >
            鲁ICP备20000134号-3</a
          ><span></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37021402002207\" target="_banck">鲁公网安备 37021402002207号</a><span class="span1">|</span
          >网站建设：<a href="#">印工社</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'resetSuccess',
  data() {
    return {};
  },
  methods: {
    init() {},
    login() {
      this.$router.push({ path: '/login' });
    },
  },
  mounted() {},
  created() {
    this.init();
  },
};
</script>

<style scoped>
.container {
  background-color: #273142;
  width: 100%;
  height: 100vh;
}
.dengl .yjd {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/resetsuccess.vue